module.exports = __webpack_public_path__ + "img/secure-upload.cc22289a.svg";